import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { trackWhatsAppClick } from './MetaPixel';
export function WhatsAppFloat() {
  return <motion.a href="https://wa.me/5491145263003" target="_blank" rel="noopener noreferrer" onClick={trackWhatsAppClick} aria-label="Contactar a Freddy por WhatsApp" initial={{
    opacity: 0,
    scale: 0.5,
    y: 20
  }} animate={{
    opacity: 1,
    scale: 1,
    y: 0
  }} transition={{
    delay: 1.2,
    duration: 0.6,
    ease: [0.16, 1, 0.3, 1]
  }} whileHover={{
    scale: 1.08
  }} whileTap={{
    scale: 0.95
  }} className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-50 flex items-center justify-center w-14 h-14 md:w-16 md:h-16 bg-[#25D366] text-white rounded-full shadow-2xl shadow-[#25D366]/40 hover:bg-[#1DA851] transition-colors duration-300 group" data-id="element-342" data-mp="29varpjw40d9v">
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-50 animate-ping" data-id="element-343" data-mp="3gal12fldwl8f"></span>

      <MessageCircle className="w-7 h-7 md:w-8 md:h-8 relative z-10" fill="currentColor" strokeWidth={0} data-id="element-344" data-mp="3k9lgdo4nl5qo" />

      {/* Tooltip */}
      <span className="absolute right-full mr-4 px-4 py-2 bg-ink text-ivory text-sm whitespace-nowrap rounded-md border border-gold/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none hidden md:block" data-id="element-345" data-mp="3bibftcv7s9ch">
        Hablar con Freddy
      </span>
    </motion.a>;
}